var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isEditing
    ? _c(
        "div",
        [
          _c("bulma-carousel-modal", {
            attrs: {
              active: _vm.modalOpen,
              closable: true,
              "start-index": _vm.selectedImage,
              "image-ids": _vm.imageIds,
              "image-height": 1000,
              "image-width": 1000,
            },
            on: { close: _vm.close },
          }),
          _c("div", { staticClass: "tile is-ancestor is-parent" }, [
            _c("div", { staticClass: "tile is-parent" }, [
              !_vm.isLoadingImages
                ? _c(
                    "div",
                    {
                      staticClass: "is-flex is-flex-wrap-wrap flex-full-width",
                    },
                    [
                      _c(
                        "article",
                        { staticClass: "tile is-child" },
                        [
                          _vm._l(_vm.imageCategories, function (category) {
                            return [
                              _vm.refreshComponent
                                ? _c("quote-image-category", {
                                    key: category.quoteImageCategoryId,
                                    ref: "quoteImageCategories",
                                    refInFor: true,
                                    attrs: {
                                      categories: _vm.imageCategories,
                                      images: _vm.imagesWithInfo,
                                      "quote-id": _vm.value.quoteId,
                                      category: category.name,
                                      "category-id":
                                        category.quoteImageCategoryId,
                                      "category-order-index":
                                        category.orderIndex,
                                      "is-private": category.isPrivate,
                                      value: _vm.value,
                                      "has-select": _vm.hasSeclectAll,
                                      refresh: _vm.refreshCategory,
                                      "is-category-select-all-enable": false,
                                      "is-delete-enable": false,
                                      "is-image-selectable": false,
                                    },
                                    on: {
                                      "update-image": _vm.updateImage,
                                      "arrange-images-order":
                                        _vm.arrangeImagesOrder,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isLoadingImages,
                  expression: "isLoadingImages",
                },
              ],
              staticClass: "columns is-multiline",
            },
            [_vm._m(0)]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section" }, [
      _c("span", {
        staticClass: "is-loading-image has-text-black has-text-centered",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }